/* REQ-003 首页卖点手风琴：互斥展开 + 右侧媒体联动 */
if (!customElements.get('feature-accordion')) {
  customElements.define(
    'feature-accordion',
    class FeatureAccordion extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.feature-accordion__item'));
        this.mediaItems = Array.from(this.querySelectorAll('.feature-accordion__media-item'));

        this.items.forEach((item) => {
          /* 始终保持恰好一项展开：点击已展开项不收起（与参考站行为一致） */
          const summary = item.querySelector('summary');
          if (summary) {
            summary.addEventListener('click', (event) => {
              if (item.open) event.preventDefault();
            });
          }

          item.addEventListener('toggle', () => {
            if (!item.open) return;
            this.items.forEach((other) => {
              if (other !== item) other.open = false;
            });
            this.setActiveMedia(item.dataset.index);
          });
        });

        /* 主题编辑器中选中某个卖点 block 时展开对应项 */
        document.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest && event.target.closest('.feature-accordion__item');
          if (item && this.contains(item)) item.open = true;
        });

        this.syncVideos();
      }

      setActiveMedia(index) {
        this.mediaItems.forEach((media) => {
          const isActive = media.dataset.index === index;
          media.classList.toggle('is-active', isActive);
          const video = media.querySelector('video');
          if (!video) return;
          if (isActive) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      syncVideos() {
        this.mediaItems.forEach((media) => {
          const video = media.querySelector('video');
          if (video && !media.classList.contains('is-active')) video.pause();
        });
      }
    }
  );
}
